import { useEffect } from 'react';

const useAlertFading = (alertState, setAlertState, alertKey, setFadingAlerts) => {
    useEffect(() => {
        let timer;
        if (alertState) {
            timer = setTimeout(() => {
                setFadingAlerts(prev => ({ ...prev, [alertKey]: true }));
                setTimeout(() => setAlertState(false), 300);
            }, 5000);
        }
        return () => clearTimeout(timer);
    }, [alertState, alertKey, setAlertState, setFadingAlerts]);

    useEffect(() => {
        if (alertState) {
            setFadingAlerts(prev => ({ ...prev, [alertKey]: false }));
        }
    }, [alertState, alertKey, setFadingAlerts]);
};

export default useAlertFading; 